// Brand logo data - 27 logos (9-9-9 equal distribution)
// OPTIMIZED FOR BOTH WEB & MOBILE: TheLifeCo center middle, Euphrosyn upper-center
export const allBrands = [
  // TOP ROW (9 logos) - Scrolls right - EUPHROSYN at CENTER (new prime brand — visible on both web & mobile)
  { id: 'profilo', name: 'Profilo', src: '/brands/profilo.png', bgColor: 'white' },
  { id: 'friendsoforka', name: 'Friends of Orka', src: '/brands/ORKA-LOGO-1.avif', bgColor: 'red' },
  { id: 'chacha', name: 'ChaCha', src: '/brands/chacha.avif', bgColor: 'white' },
  { id: 'sickscience', name: 'Sick Science', src: '/brands/sickscience.avif', bgColor: 'white' },
  { id: 'euphrosyn', name: 'Euphrosyn', src: '/brands/euphrosyn.webp', bgColor: 'white', scale: 1.6 }, // 🌟 UPPER CENTER (web: top-mid | mobile: visible)
  { id: 'novation', name: 'Novation', src: '/brands/novation.webp', bgColor: 'black' },
  { id: 'imuneks', name: 'İmuneks Farma', src: '/brands/imuneks.png', bgColor: 'white' },
  { id: 'mnnutra', name: 'Mn Nutra', src: '/brands/mnnutra.avif', bgColor: 'white' },
  { id: 'sachane', name: 'SaçHane', src: '/brands/sachane.svg', bgColor: 'white' },
  
  // MIDDLE ROW (9 logos) - MOST VISIBLE - TheLifeCo CENTER
  { id: 'goso', name: 'Go & So', src: '/brands/goso.jpg', bgColor: 'white' },
  { id: 'rarfoods', name: 'Rar Foods', src: '/brands/rarfoods.avif', bgColor: 'white' },
  { id: 'anti', name: 'Anti', src: '/brands/anti.webp', bgColor: 'white' },
  { id: 'cellule', name: 'Cellule', src: '/brands/cellule.webp', bgColor: 'white' },
  { id: 'tlc', name: 'The Life Co', src: '/brands/tlc.svg', bgColor: 'white' }, // 🌟🌟 EXACT CENTER (web & mobile: maximum visibility!)
  { id: 'peticim', name: 'Petiçim', src: '/brands/peticim.png', bgColor: 'white' },
  { id: 'iyiyasam', name: 'İyi Yaşam', src: '/brands/iyiyasam.webp', bgColor: 'white' },
  { id: 'defya', name: 'Defya', src: '/brands/defya.png', bgColor: 'white' },
  { id: 'ecowell', name: 'Ecowell', src: '/brands/ecowell.avif', bgColor: 'white' },
  
  // BOTTOM ROW (9 logos) - Saf at END (moved from top-center to make room for Euphrosyn)
  { id: 'noibahce', name: 'NOİ Bahçe', src: '/brands/noibahce.avif', bgColor: 'white' },
  { id: 'marieclaire', name: 'Marie Claire', src: '/brands/marieclaire.png', bgColor: 'white' },
  { id: 'stemcell', name: 'The Stem Cell Lab', src: '/brands/stemcell.png', bgColor: 'white' },
  { id: 'ralila', name: 'Ralila', src: '/brands/ralila.webp', bgColor: 'white' },
  { id: 'sitrex', name: 'Sitrex', src: '/brands/sitrex.webp', bgColor: 'white' },
  { id: 'radika', name: 'Radika Aroma', src: '/brands/radika.webp', bgColor: 'white' },
  { id: 'ersu', name: 'Ersu', src: '/brands/ersu.webp', bgColor: 'white' },
  { id: 'tfll', name: 'TFLL Pharma', src: '/brands/tfll.png', bgColor: 'white' },
  { id: 'saf', name: 'Saf', src: '/brands/saf.avif', bgColor: 'white' }, // Moved here from top-center to accommodate Euphrosyn
];

// Equal distribution: 9-9-9 (Total 27 logos)
// OPTIMIZED FOR WEB & MOBILE:
// TheLifeCo: Middle center (best for both) | Saf: Top center (visible on both) | Lalive: Bottom end
export const getBrandRows = () => ({
  topRow: allBrands.slice(0, 9),      // 9 logos × 2 = 18 boxes (Saf at center)
  middleRow: allBrands.slice(9, 18),  // 9 logos × 2 = 18 boxes (TheLifeCo at center)
  bottomRow: allBrands.slice(18, 27), // 9 logos × 2 = 18 boxes (Lalive at end)
});
